/* eslint-disable no-console */

interface ILogContent {
  icon?: string;
  title?: string;
  body: any;
}

const LOGGER_KEY = "WIENI_LOGS";

class LoggerService {
  constructor() {
    const currentEnv = process.env.REACT_APP_WIENI_ENV || "local";

    if (currentEnv !== "production") {
      console.log(
        `%c🌈 Hi, welcome to Wieni logger for Mediawijs on ${currentEnv}.\n To see the logs, set WIENI_LOGS=true in your local storage, or use one of these helpers:`,
        "color: #ff3d9a;"
      );
      console.table({
        "Enable Wieni logs": "window.enableWieniLogs()",
        "Disable Wieni logs": "window.disableWieniLogs()",
      });
      console.log(
        `%c🌈 Logs are ${this.logsEnabled() ? "✅ enabled" : "❌ disabled"}`,
        "color: #ff3d9a;"
      );
    }

    window.enableWieniLogs = () => {
      window.localStorage.setItem(LOGGER_KEY, "true");
    };

    window.disableWieniLogs = () => {
      window.localStorage.setItem(LOGGER_KEY, "");
    };
  }

  private static getLoggerKey(): string | null {
    const value = localStorage.getItem(LOGGER_KEY);
    return value;
  }

  // Check if "WIENI_LOGS" is set to true in local storage
  private logsEnabled(): boolean {
    const value = LoggerService.getLoggerKey();
    return value && JSON.parse(value);
  }

  log = ({ icon, title, body }: ILogContent) => {
    if (this.logsEnabled()) {
      console.group(icon, title);
      console.log(body);
      console.groupEnd();
    }
  };
}

// Make sure only one instance of LoggerService is created
const loggerService = new LoggerService();
Object.freeze(loggerService);

export { loggerService };
